import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { ChartWrapper, ColWrapper } from './RiskLineChart.elements'

// Views
import { LineChart } from 'views/components'

function RiskLineChart(props) {
  // Destructure
  const { data, options } = props

  return (
    <ChartWrapper>
      <ColWrapper>
        <LineChart data={data} width={200} height={200} options={options} />
      </ColWrapper>
    </ChartWrapper>
  )
}

// Default Props
RiskLineChart.defaultProps = {
  data: { label: [], datasets: [] },
  options: {},
}

// Proptypes Validation
RiskLineChart.propTypes = {
  data: PropTypes.shape({}),
  options: PropTypes.shape({}),
}

export default RiskLineChart
